module.exports = {"TXTWCL_RatingX_N0_out_of_N1_stars":{"id":"TXTWCL_RatingX_N0_out_of_N1_stars","defaultMessage":"レーティング: 星 {1} つが満点で {0}"}}